import * as React from 'react'
import { SelectAjaxSeeker } from 'ui-seeker/core'

import { ALERTS } from 'app/@common/constants'


export default function SelectComparison({ ...props }) {
    const myProps = {
        urlAjax: `${ALERTS.COMPARISON_LIST}/${props.alertType || ''}`,
        label: 'Comparison',
        isClearable: true, firstSelect: false, isMulti: true,
        icon: { icon: 'calculator-alt' },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}